(function () {
  function openItem(item) {
    const section = item.closest('[data-ff-product-accordion]');
    if (!section) return;

    section.querySelectorAll('[data-ff-product-accordion-item]').forEach((accordionItem) => {
      const trigger = accordionItem.querySelector('[data-ff-product-accordion-trigger]');
      const panel = accordionItem.querySelector('[data-ff-product-accordion-panel]');
      const isActive = accordionItem === item;

      accordionItem.classList.toggle('is-open', isActive);
      if (trigger) trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      if (panel) panel.hidden = !isActive;
    });
  }

  function toggleItem(item) {
    const isOpen = item.classList.contains('is-open');
    if (isOpen) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-ff-product-accordion-trigger]');
      const panel = item.querySelector('[data-ff-product-accordion-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      return;
    }

    openItem(item);
  }

  function initProductTabs(root) {
    if (!root || root.dataset.ffTabsInit === 'true') return;
    root.dataset.ffTabsInit = 'true';

    root.querySelectorAll('[data-ff-product-accordion-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('[data-ff-product-accordion-item]');
        if (item) toggleItem(item);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ff-product-tabs').forEach(initProductTabs);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
